import classNames from 'classnames';
import { LogNotification, LogNotifyType } from '@/api';
import BroadcastIcon from './assets/broadcast.svg?react';
import SwordsIcon from './assets/swords.svg?react';
import TrophyIcon from './assets/trophy.svg?react';
import MailIcon from './assets/mail.svg?react';
import styles from './styles.module.scss';

const TypeGlyph = ({ type }: { type?: LogNotifyType }) => {
    if (type === LogNotifyType.NOTIFY_TYPE_BROADCAST) {
        return <BroadcastIcon aria-hidden="true" />;
    }
    if (type === LogNotifyType.NOTIFY_TYPE_TOURNAMENT) {
        return <TrophyIcon aria-hidden="true" />;
    }
    if (type === LogNotifyType.NOTIFY_TYPE_GAME) {
        return <SwordsIcon aria-hidden="true" />;
    }
    return <MailIcon aria-hidden="true" />;
};

export const NotificationIcon = ({ notification }: { notification: LogNotification }) => {
    const avatarId = notification.messageData?.user_id;
    const type = notification.type ?? LogNotifyType.NOTIFY_TYPE_UNSPECIFIED;

    if (avatarId) {
        return (
            <span className={styles.avatarWrapper}>
                <span
                    className={styles.avatar}
                    style={{
                        background: `center / cover no-repeat url(/api/v1/avatars/${avatarId}.png), center / 70% no-repeat url(/comet.svg), white`,
                    }}
                />
                <span className={classNames(styles.avatarBadge, styles[type])}>
                    <TypeGlyph type={type} />
                </span>
            </span>
        );
    }

    return (
        <span className={classNames(styles.typeIcon, styles[type])}>
            <TypeGlyph type={type} />
        </span>
    );
};
